import React from "react";
import { useTranslation } from "react-i18next";
import { formatAmount } from "./utils";
import { formatDate } from "../../utils/dateFormat";

export default function DeliveryNoteDetailsNoteTable({ deliveryNote }) {
  const { t } = useTranslation();

  return (
    <div className="table-responsive">
      <table className="table table-delivery_note table-hover">
        <thead>
          <tr>
            <th>{t("items.line")}</th>
            <th>{t("items.number")}</th>
            <th>{t("items.name")}</th>
            <th>{t("items.groups.group")}</th>
            <th>{t("delivery_notes.next_date_of_inspection")}</th>
            <th className="text-end">{t("items.amount")}</th>
          </tr>
        </thead>
        <tbody>
          {deliveryNote.items.map((item) => (
            <tr key={item.id}>
              <td width={1}>{item.line}</td>
              <td width={1}>{item.number}</td>
              <td className="text-wrap">
                {item.name}
                {item.attributes.length > 0 && (
                  <table>
                    <tbody>
                      {item.attributes
                        .filter((attr) => !!attr.data.values[0])
                        .map((attr, i) => (
                          <tr key={i} className={`${i % 2 || "bg-light"}`}>
                            <td className="py-1">{attr.name}:</td>
                            <td className="ps-4">{attr.data.values[0]}</td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                )}
              </td>
              <td className="text-wrap">
                <ul className="list-group list-unstyled">
                  {item.groups.map((group) => (
                    <li key={group.id}>{group.name}</li>
                  ))}
                </ul>
              </td>
              <td width={1} className="text-nowrap">
                {!!item.next_date_of_inspection &&
                  formatDate(item.next_date_of_inspection)}
              </td>
              <td className="text-end" width={1}>
                {formatAmount(item.amount)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
